/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import CustomToolbar from '../../common/CustomToolbar/CustomToolbar';
import globals from '../../../globals/communityGlobals';
import _ from '../../../utils/lodash';

const locale = globals.getAreas(['mileageCap', 'error']);
const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = ['Forename', 'Surname', 'StaffNumber'];
  const dtoNames = ['firstName', 'lastName', 'staffNumber'];

  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }

  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

export const tableSettings = options => ({
  name: <Typography variant="h3">Mileage Cap</Typography>,
  columns: [
    {
      name: 'id',
      label: 'Id',
      options: {
        display: 'excluded',
      },
    },
    {
      name: 'clinicianId',
      label: 'ClinicianId',
      options: {
        display: 'excluded',
      },
    },
    {
      name: 'firstName',
      label: locale.getMsg('forename'),
      options: {
        sortOrder: {
          name: 'firstName',
          direction: setSortDirection('firstName', options),
        },
      },
    },
    {
      name: 'lastName',
      label: locale.getMsg('surname'),
      options: {
        sortOrder: {
          name: 'lastName',
          direction: setSortDirection('lastName', options),
        },
      },
    },
    {
      name: 'staffNumber',
      label: locale.getMsg('staffNumber'),
      options: {
        sortOrder: {
          name: 'staffNumber',
          direction: setSortDirection('staffNumber', options),
        },
      },
    },
    {
      name: 'postCode',
      label: locale.getMsg('baseLocation'),
      options: {
        sort: false,
      },
    },
    {
      name: 'mileageCap',
      label: locale.getMsg('defaultMileageCap'),
      options: {
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let mileageCapValue = value;
          const clinicianId = tableMeta.rowData[1];
          if (clinicianId in options.mileageCapList) {
            mileageCapValue = options.mileageCapList[clinicianId].mileageCap;
          }

          return (
            <TextField
              placeholder={'Enter value'}
              value={mileageCapValue}
              error={mileageCapValue === ''}
              type="number"
              required
              className="slick-mui-textbox"
              style={{ width: '130px', padding: '0px' }}
              onChange={e =>
                options.eventHandlers.updateMileageCapValue({
                  id: tableMeta.rowData[0],
                  clinicianId,
                  oldMileageCap: value,
                  mileageCap: e.target.value,
                })
              }
            />
          );
        },
      },
    },
    {
      name: 'createdOn',
      label: locale.getMsg('lastUpdated'),
      options: {
        sort: false,
        empty: true,
        customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
      },
    },
  ],
  options: {
    filterType: 'dropdown',
    responsive: 'standard',
    selectableRows: 'none',
    rowsPerPageOptions: [5, 15, 30, 50, 100],
    rowsPerPage: options.pageSize,
    print: true,
    search: false,
    filter: false,
    serverSide: true,
    count: options.count,
    page: options.page,
    customToolbar: () => (
      <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isTableDataLoading} />
    ),
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
        case 'changeRowsPerPage':
          options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
          break;
        case 'sort':
          let sortColumn = '';
          let sortDirection = '';

          if (tableState.activeColumn > -1) {
            sortColumn = mapPropName(tableState.sortOrder.name);
            sortDirection = tableState.sortOrder.direction;
            options.eventHandlers.updateTableSort(sortColumn, sortDirection);
          }
          break;
      }
    },
  },
});
